import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { PaymentLogos } from './PaymentLogos';
function PrivacyModal({
  onClose
}: {
  onClose: () => void;
}) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-150">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} transition={{
      duration: 0.3
    }} className="bg-white rounded-2xl shadow-xl max-w-[700px] w-full max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-151">
        <div className="flex items-center justify-between px-6 py-4 border-b border-charcoal/10 shrink-0" data-id="element-152">
          <h2 className="text-lg font-bold text-charcoal" data-id="element-153">
            📄 Política de Privacidad
          </h2>
          <button onClick={onClose} className="text-charcoal/50 hover:text-charcoal transition-colors p-1" data-id="element-154">
            <X className="w-5 h-5" data-id="element-155" />
          </button>
        </div>

        <div className="overflow-y-auto px-6 py-6 text-sm text-charcoal/80 leading-relaxed space-y-6" data-id="element-156">
          <p className="text-xs text-charcoal/50" data-id="element-157">
            📅 Última actualización: 31/03/2026
          </p>

          <section data-id="element-158">
            <h3 className="font-bold text-charcoal mb-2" data-id="element-159">1. Introducción</h3>
            <p data-id="element-160">
              Valordigital gestiona esta tienda y sitio web, incluyendo datos,
              contenido, funciones, herramientas, productos y servicios (los
              "Servicios"), con tecnología de Shopify.
            </p>
            <p className="mt-2" data-id="element-161">
              Esta Política de Privacidad explica cómo se recopila, utiliza y
              divulga tu información personal cuando:
            </p>
            <ul className="mt-2 space-y-1" data-id="element-162">
              <li data-id="element-163">✔️ Visitás el sitio</li>
              <li data-id="element-164">✔️ Usás los servicios</li>
              <li data-id="element-165">✔️ Realizás compras o transacciones</li>
              <li data-id="element-166">✔️ Te comunicás con la empresa</li>
            </ul>
            <p className="mt-2" data-id="element-167">
              👉 En caso de conflicto con los Términos del Servicio, prevalece
              esta Política respecto a datos personales.
            </p>
          </section>

          <section data-id="element-168">
            <h3 className="font-bold text-charcoal mb-2" data-id="element-169">
              2. Información personal que se recopila
            </h3>
            <p data-id="element-170">
              Se entiende por "información personal" cualquier dato que permita
              identificarte directa o indirectamente.
            </p>
            <p className="mt-2 font-medium text-charcoal" data-id="element-171">
              📌 Tipos de datos recopilados
            </p>
            <ul className="mt-2 space-y-1" data-id="element-172">
              <li data-id="element-173">
                <strong data-id="element-174">Datos de contacto:</strong> Nombre, dirección, email,
                teléfono
              </li>
              <li data-id="element-175">
                <strong data-id="element-176">Información financiera:</strong> Tarjetas, pagos,
                transacciones
              </li>
              <li data-id="element-177">
                <strong data-id="element-178">Datos de cuenta:</strong> Usuario, contraseña,
                preferencias
              </li>
              <li data-id="element-179">
                <strong data-id="element-180">Información de transacciones:</strong> Compras, carrito,
                devoluciones
              </li>
              <li data-id="element-181">
                <strong data-id="element-182">Comunicaciones:</strong> Mensajes enviados al soporte
              </li>
              <li data-id="element-183">
                <strong data-id="element-184">Información del dispositivo:</strong> IP, navegador,
                conexión
              </li>
              <li data-id="element-185">
                <strong data-id="element-186">Datos de uso:</strong> Cómo navegás e interactuás con el
                sitio
              </li>
            </ul>
          </section>

          <section data-id="element-187">
            <h3 className="font-bold text-charcoal mb-2" data-id="element-188">
              3. Fuentes de información
            </h3>
            <p data-id="element-189">Los datos se obtienen de:</p>
            <ul className="mt-2 space-y-1" data-id="element-190">
              <li data-id="element-191">✔️ Directamente del usuario</li>
              <li data-id="element-192">✔️ Automáticamente (cookies y tecnología)</li>
              <li data-id="element-193">✔️ Proveedores de servicios</li>
              <li data-id="element-194">✔️ Partners o terceros</li>
            </ul>
          </section>

          <section data-id="element-195">
            <h3 className="font-bold text-charcoal mb-2" data-id="element-196">
              4. Cómo se usa la información
            </h3>
            <p className="font-medium text-charcoal" data-id="element-197">🎯 Principales usos</p>
            <ul className="mt-2 space-y-1" data-id="element-198">
              <li data-id="element-199">
                <strong data-id="element-200">Prestación del servicio:</strong> Procesar pedidos,
                pagos, envíos
              </li>
              <li data-id="element-201">
                <strong data-id="element-202">Personalización:</strong> Recomendaciones y experiencia
                adaptada
              </li>
              <li data-id="element-203">
                <strong data-id="element-204">Marketing y publicidad:</strong> Emails, anuncios,
                promociones
              </li>
              <li data-id="element-205">
                <strong data-id="element-206">Seguridad:</strong> Prevención de fraude y protección
              </li>
              <li data-id="element-207">
                <strong data-id="element-208">Atención al cliente:</strong> Responder consultas
              </li>
              <li data-id="element-209">
                <strong data-id="element-210">Cumplimiento legal:</strong> Obligaciones legales y
                procesos judiciales
              </li>
            </ul>
          </section>

          <section data-id="element-211">
            <h3 className="font-bold text-charcoal mb-2" data-id="element-212">
              5. Cómo se comparte la información
            </h3>
            <p data-id="element-213">Se puede compartir con:</p>
            <ul className="mt-2 space-y-1" data-id="element-214">
              <li data-id="element-215">🛠️ Proveedores (pagos, envíos, IT)</li>
              <li data-id="element-216">📢 Partners de marketing</li>
              <li data-id="element-217">🤝 Afiliados del negocio</li>
              <li data-id="element-218">⚖️ Autoridades legales</li>
            </ul>
            <p className="mt-2" data-id="element-219">
              👉 También cuando el usuario lo autoriza o solicita.
            </p>
          </section>

          <section data-id="element-220">
            <h3 className="font-bold text-charcoal mb-2" data-id="element-221">
              6. Relación con Shopify
            </h3>
            <p data-id="element-222">
              El sitio funciona sobre Shopify, que también recopila y procesa
              datos para:
            </p>
            <ul className="mt-2 space-y-1" data-id="element-223">
              <li data-id="element-224">✔️ Mejorar los servicios</li>
              <li data-id="element-225">✔️ Personalizar la experiencia</li>
              <li data-id="element-226">✔️ Gestionar funcionalidades avanzadas</li>
            </ul>
            <p className="mt-2" data-id="element-227">
              👉 Shopify puede usar datos provenientes de múltiples tiendas
              dentro de su plataforma.
            </p>
          </section>

          <section data-id="element-228">
            <h3 className="font-bold text-charcoal mb-2" data-id="element-229">
              7. Sitios de terceros
            </h3>
            <p data-id="element-230">El sitio puede incluir enlaces externos.</p>
            <p className="mt-1" data-id="element-231">
              ⚠️ No se garantiza la seguridad ni privacidad en esos sitios.
            </p>
          </section>

          <section data-id="element-232">
            <h3 className="font-bold text-charcoal mb-2" data-id="element-233">
              8. Datos de menores
            </h3>
            <ul className="space-y-1" data-id="element-234">
              <li data-id="element-235">✔️ No está dirigido a menores</li>
              <li data-id="element-236">✔️ No se recopilan datos intencionalmente</li>
              <li data-id="element-237">✔️ Padres pueden solicitar eliminación de datos</li>
            </ul>
          </section>

          <section data-id="element-238">
            <h3 className="font-bold text-charcoal mb-2" data-id="element-239">
              9. Seguridad y retención
            </h3>
            <ul className="space-y-1" data-id="element-240">
              <li data-id="element-241">✔️ No existe seguridad 100% garantizada</li>
              <li data-id="element-242">
                ✔️ Se recomienda no enviar datos sensibles por canales inseguros
              </li>
              <li data-id="element-243">
                ✔️ Los datos se conservan según necesidad legal y operativa
              </li>
            </ul>
          </section>

          <section data-id="element-244">
            <h3 className="font-bold text-charcoal mb-2" data-id="element-245">
              10. Derechos del usuario
            </h3>
            <p data-id="element-246">Dependiendo del país, podés tener derecho a:</p>
            <ul className="mt-2 space-y-1" data-id="element-247">
              <li data-id="element-248">📂 Acceder a tus datos</li>
              <li data-id="element-249">❌ Solicitar eliminación</li>
              <li data-id="element-250">✏️ Rectificar información</li>
              <li data-id="element-251">📦 Portabilidad de datos</li>
              <li data-id="element-252">📩 Gestionar comunicaciones (opt-out de marketing)</li>
            </ul>
            <p className="mt-2" data-id="element-253">
              👉 Puede requerirse verificación de identidad.
            </p>
          </section>

          <section data-id="element-254">
            <h3 className="font-bold text-charcoal mb-2" data-id="element-255">11. Reclamaciones</h3>
            <p data-id="element-256">Podés:</p>
            <ul className="mt-2 space-y-1" data-id="element-257">
              <li data-id="element-258">✔️ Contactar directamente a la empresa</li>
              <li data-id="element-259">✔️ Reclamar ante autoridades de protección de datos</li>
            </ul>
          </section>

          <section data-id="element-260">
            <h3 className="font-bold text-charcoal mb-2" data-id="element-261">
              12. Transferencias internacionales
            </h3>
            <p data-id="element-262">Los datos pueden almacenarse o procesarse fuera de tu país.</p>
            <p className="mt-1" data-id="element-263">Se utilizan mecanismos legales como:</p>
            <ul className="mt-1" data-id="element-264">
              <li data-id="element-265">✔️ Cláusulas contractuales estándar (SCC)</li>
            </ul>
          </section>

          <section data-id="element-266">
            <h3 className="font-bold text-charcoal mb-2" data-id="element-267">
              13. Cambios en la política
            </h3>
            <p data-id="element-268">
              La política puede actualizarse en cualquier momento. Se notificará
              según lo exija la ley.
            </p>
          </section>

          <section data-id="element-269">
            <h3 className="font-bold text-charcoal mb-2" data-id="element-270">14. Contacto</h3>
            <p data-id="element-271">📧 Email: soportevalordigitalpro@gmail.com</p>
            <p data-id="element-272">📍 Dirección: Av. Libertador 4800, Buenos Aires, Argentina</p>
          </section>
        </div>
      </motion.div>
    </motion.div>;
}
function RefundModal({
  onClose
}: {
  onClose: () => void;
}) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-273">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} transition={{
      duration: 0.3
    }} className="bg-white rounded-2xl shadow-xl max-w-[500px] w-full overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-274">
        <div className="flex items-center justify-between px-6 py-4 border-b border-charcoal/10" data-id="element-275">
          <h2 className="text-lg font-bold text-charcoal" data-id="element-276">
            💳 Política de Reembolso
          </h2>
          <button onClick={onClose} className="text-charcoal/50 hover:text-charcoal transition-colors p-1" data-id="element-277">
            <X className="w-5 h-5" data-id="element-278" />
          </button>
        </div>
        <div className="px-6 py-6 text-sm text-charcoal/80 leading-relaxed space-y-4" data-id="element-279">
          <p data-id="element-280">
            Como este es un producto digital y de acceso inmediato,{' '}
            <strong className="text-charcoal" data-id="element-281">no realizamos reembolsos</strong>{' '}
            una vez realizada la compra.
          </p>
          <p data-id="element-282">
            Sin embargo, si tenés algún problema con la descarga o el acceso,
            escribinos y te lo solucionamos al instante.
          </p>
          <p className="font-medium text-charcoal" data-id="element-283">
            Queremos que tengas una gran experiencia. 😊
          </p>
        </div>
      </motion.div>
    </motion.div>;
}
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showRefund, setShowRefund] = useState(false);
  return <>
      <footer className="w-full py-10 px-6 bg-surface text-center" data-id="element-284">
        <div className="max-w-[900px] mx-auto flex flex-col items-center justify-center gap-4" data-id="element-285">
          <span className="text-primary font-bold tracking-widest text-sm uppercase" data-id="element-286">
            Recetas Air Fryer Argentinas
          </span>

          <p className="text-charcoal/60 text-sm" data-id="element-287">
            Diseñado con ❤️ para cocineros argentinos
          </p>

          <PaymentLogos className="mt-2" data-id="element-288" />

          <div className="flex items-center gap-4 mt-4" data-id="element-289">
            <button onClick={() => setShowPrivacy(true)} className="text-charcoal/50 hover:text-charcoal/80 text-xs underline transition-colors" data-id="element-290">
              Política de Privacidad
            </button>
            <span className="text-charcoal/30" data-id="element-291">|</span>
            <button onClick={() => setShowRefund(true)} className="text-charcoal/50 hover:text-charcoal/80 text-xs underline transition-colors" data-id="element-292">
              Política de Reembolso
            </button>
          </div>

          <p className="text-charcoal/40 text-xs mt-2" data-id="element-293">
            &copy; {currentYear} Recetas Air Fryer Argentinas. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-294">
        {showPrivacy && <PrivacyModal onClose={() => setShowPrivacy(false)} data-id="element-295" />}
        {showRefund && <RefundModal onClose={() => setShowRefund(false)} data-id="element-296" />}
      </AnimatePresence>
    </>;
}